import { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// import { conditionalRedirection } from 'assets/common/conditionalRedirection';
// import { conditionalRedirection } from 'assets/difc/conditionalRedirection';
// import { conditionalRedirection } from 'assets/adgm/conditionalRedirection';

import Layout from "components/Layout";
import DynamicForm from "components/DynamicForm";
import Recursive from "components/Recursive";

import {
  clearSelectedData,
  clearSelectedDataKey,
  clearValidateTriggered,
  setSelectedData,
} from "redux/formDisplay";
import {
  setAssociatedWf,
  setIsMinor,
  clearSaveData,
  clearShowData,
  setShowDataPreview,
  clearRecursiveFormData,
  setIsGuardianDisabled,
  setAssociatedWfAge,
  setIsAssociatedWfDisabled,
  setEditIndex,
} from "redux/recursiveReducer";
import { consentsConfig } from "redux/consentReducer";
import {
  setApplicantUser,
  setPrimaryUser,
  setworkflowUser,
} from "redux/userInfo";
import conditionalRendering, {
  incrementActiveStepOrder,
  setActiveStepOrder,
  setDynamicConfigId,
  setUserInitiatedRequired
} from "redux/conditionalRendering";
import {
  setShowData,
  setFormFields,
  setArrayName,
  setRecursiveFormData,
  setShowRecursiveForm,
  setShowAddMore,
  setRecursiveActions,
  setAddSaveData,
  clearRecursiveFormDataKey,
  setIsEditRecursiveForm,
} from "redux/recursiveReducer";
import {
  setShowData as setShowDataGuardian,
  setFormFields as setFormFieldsGuardian,
  setArrayName as setArrayNameGuardian,
  setRecursiveFormData as setRecursiveFormDataGuardian,
  setShowRecursiveForm as setShowRecursiveFormGuardian,
  setShowAddMore as setShowAddMoreGuardian,
  setRecursiveActions as setRecursiveActionsGuardian,
  setAddSaveData as setAddSaveDataGuardian,
  clearRecursiveFormDataKey as clearRecursiveFormDataKeyGuardian,
  clearRecursiveFormData as clearRecursiveFormDataGuardian,
  setIsEditRecursiveForm as setIsEditRecursiveFormGuardian,
  setAssociateRequired as setAssociateRequiredGuardian,
  setCurrentFormType as setCurrentFormTypeGuardian,
  setShowDataPreview as setShowDataPreviewGuardian,
  setEditIndex as setEditIndexGuardian
} from "redux/guardianReducer";

import {
  createPrimaryWorkFlow,
  getWorkflowData,
  updatePrimaryWorkflow,
  updateWorkflowInfo,
  createSubWorkFlow
} from "api/formDisplay";
import { checkLinkForExpiryBasedOnID, getConfiguration } from "api/configuration";
import { createMasterDataPayload } from "helper/createPayload";
import { Group } from "lib";
import FormButton from "components/FormButton";
import { validate } from "components/DynamicForm/validate";
import { dynamicFormScroll } from "utils";
import Consent from "components/Consent";
import { setConfigurationId } from "redux/conditionalRendering";
import { setOtpValues } from "redux/otpReducer";
import {
  setSections,
  setStepperDisplay,
  setBanner,
  setNavOrientation,
  setFormOccupancy,
  setAllignmentPosition,
  setCustomStyle
} from "redux/stepperReducer";
import { getConsent } from "api/consent";
import { setConsentSections } from "redux/consentReducer";
import { uniqueWorkFlowId } from "helper/uniqueWorkFlowId";
import LoadingSpinner from "lib/LoadingSpinner";
import moment from "moment";
import { setIsInternal } from "redux/usersReducer";
import { decrypt } from "helper/encryptDecrypt";
import { encryptUrl } from "api/UrlEncryption";
import { setConfigLoading } from "redux/configurationReducer";
import { getRolesInfo } from "api/user";
import { Row } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { initiateUaePassAuth } from "api/uae-pass";
import GuardianRecursive from "components/GuardianRecursive";
import { getDependentsId, getDependentsNames } from "helper";
import { encrypt } from "helper/encryptDecrypt";
// import { IndirectEval } from 'helper/indirectEval';
const ConditionalRendering = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loaction = useLocation();
  const { redirectionConfigId } = useParams();
  const userParams = useParams();
  const consentLoading = useSelector(
    (state) => state?.consentReducer?.consentConfig
  );
  const formFields = useSelector((state) => state.recursive?.formFields);

  const stepperLoading = useSelector((state) => state?.stepperReducer?.loading);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const fetchUserDataLoader = useSelector((state) => state.formData?.loading);
  const otpLoading = useSelector((state) => state?.otpReducer?.loading);
  const userDetail = useSelector((state) => state.userInfo?.userDetail);
  const dataPreview = useSelector((state) => state.recursive?.showDataPreview);
  const dataPreviewGuardian = useSelector((state) => state.guardianRecursive?.showDataPreview);
  const saveData = useSelector((state) => state.recursive?.saveData);
  const saveDataGuardian = useSelector((state) => state.guardianRecursive?.saveData);
  const activeStepOrder = useSelector(
    (state) => state.conditionalRendering?.activeStepOrder
  );
  const dynamicConfigId = useSelector(
    (state) => state.conditionalRendering?.dynamicConfigId
  );
  const configurationId = useSelector(
    (state) => state.conditionalRendering?.configurationId
  );
  const primaryWorkflowId = useSelector(
    (state) => state.conditionalRendering?.primaryWorkflowId
  );

  // const userToken =
  // localStorage.getItem("userToken") &&
  // JSON.parse(localStorage.getItem("userToken"));
  const showAccountList = useSelector(
    (state) => state.conditionalRendering?.showAccountList
  );
  const sub_id = useSelector((state) => state.userInfo?.subId);
  const isEmailVerified = useSelector(
    (state) => state.otpReducer?.isEmailVerified
  );
  const email = useSelector((state) => state.otpReducer?.email);
  const applicantUserEmail = useSelector(
    (state) => state?.userInfo?.applicantUser?.email
  );
  const applicantUserMobileCountryCode = useSelector(
    (state) => state?.userInfo?.applicantUser?.country_code
  );
  const applicantUserMobileNumber = useSelector(
    (state) => state?.userInfo?.applicantUser?.mobile_number
  );
  const isMobileVerified = useSelector(
    (state) => state.otpReducer?.isMobileVerified
  );
  const consentsConfig = useSelector(
    (state) => state?.consentReducer?.consentConfig?._id
  );
  const consentText = useSelector(
    (state) => state?.consentReducer?.consentText
  );
  const consentType = useSelector(
    (state) => state?.consentReducer?.consentConfig?.service_name
  );

  const conditionalRedirection = useSelector(
    (state) => state.configurationReducer?.config
  );

  // Comment to run from frontend
  const organisation_id = conditionalRedirection?.organisation_id;

  const loading = useSelector((state) => state.configurationReducer?.loading);
  const showRecursiveForm = useSelector(
    (state) => state.recursive.showRecursiveForm
  );
  const showRecursiveFormGuardian = useSelector(
    (state) => state.guardianRecursive.showRecursiveForm
  );
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const recursiveFormDataGuardian = useSelector(
    (state) => state.guardianRecursive?.recursiveFormData
  );
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const associatedWf = useSelector((state) => state.recursive.associatedWf);
  const isMinor = useSelector((state) => state.recursive.isMinor);
  const isEditRecursiveForm = useSelector(
    (state) => state.recursive.isEditRecursiveForm
  );
  const associateRequired = useSelector(
    (state) => state?.recursive?.associateRequired
  );
  const currentFormType = useSelector(
    (state) => state?.recursive?.currentFormType
  );
  const arrayName = useSelector((state) => state?.recursive?.arrayName);

  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  const recursive = useSelector((state) => state.recursive);
  const consents = useSelector(
    (state) => state?.formData?.selectedData?.consents
  ); //* here
  const receivedConsent = useSelector(
    (state) => state?.consentReducer?.consentConfig
  );
  const activeSection = useSelector((state) => state.userInfo.activeSection);
  const userInfoLoading = useSelector((state) => state.userInfo.loading);
  const stepperSections = useSelector(
    (state) => state?.stepperReducer?.sections
  );
  const isRMClicked = useSelector((state) => state?.usersReducer?.isClicked);
  const isInternal = useSelector(
    (state) => state?.usersReducer?.isInternal
  );
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo);
  const staticData = useSelector((state) => state?.staticData);
  const currentStep = useSelector((state) => state.stepperReducer?.sections[1]?.form_groups.find(group => group.group_order === activeStepOrder))
  const userInitatedRequired = useSelector((state) => state.conditionalRendering?.userInitatedRequired)
  const navOrientation = useSelector((state) => state.stepperReducer.navOrientation)
  const cutstomStyle = useSelector((state)=> state.stepperReducer.customStyle)
  const allignmentPosition = useSelector((state) => state.stepperReducer.allignmentPosition)
  const isAPILoadingForLinkExpiryValidation = useSelector((state) => state?.conditionalRendering?.isAPILoadingForLinkExpiryValidation)
  const formData = useSelector(state => state?.formData)

  // using this Key for eval dont delete
  const guardianKey = useSelector((state) => state.guardianRecursive.guardianKey)

  let formSkeleton = {},
    sections = {},
    finalPayload,
    fields,
    banner = {};
  // const [conditionalSection, setConditionalSection] = useState({});
  const [formErr, setFormErr] = useState({});

  //Mobile Responsivess state
  const [isMobile, setIsMobile] = useState(false);
  const [isCreateWorkFlowLoading, setIsCreateWorkFlowLoading] = useState(false);

  const stateErrRef = useRef();
  const selectedDataRef = useRef();

  stateErrRef.current = { ...formErr };
  selectedDataRef.current = { ...selectedData };

  const guardianRecursive = useSelector((state) => state.guardianRecursive);

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };


  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("physical_form");
  

  useEffect(() => {
    if (!conditionalRedirection?.wf_journey?.find(item => (item.module_name === 'Conditional Redirection')))
    dispatch(setConfigLoading(true))
    const fetchData = async () => {
      if (
        decryptedId?.primaryWorkflowId &&
        decryptedId?.userId &&
        (!Object.keys(primaryUser).length||
        !Object.keys(applicantUser).length)
      ) {
        let response = await getWorkflowData(decryptedId?.primaryWorkflowId);
        if (response) {
          dispatch(setPrimaryUser(response));
          if (
            response?.active_step !== 1 &&
            Object.keys(loggedInUserInfo).length === 0 &&
            !isAPILoadingForLinkExpiryValidation
          )
            navigate("/update-successful");
          let subworkflowsObj = response?.source_data?.subworkflows?.find(
            (item) => item.user_id == decryptedId?.userId
          );
          if (subworkflowsObj) {
            let res = await getWorkflowData(subworkflowsObj?._id);
            if (
              res?.active_step !== 1 &&
              Object.keys(loggedInUserInfo).length === 0 &&
              !isAPILoadingForLinkExpiryValidation
            ) {
              navigate("/update-successful");
            }
          }
         
          if (
            !conditionalRedirection?.wf_journey?.find(
              (item) => item.module_name === "Conditional Redirection"
            )
          ) {
            dispatch(getConfiguration(response?.configuration_id));
          }
          (!applicantUser || !Object.keys(applicantUser).length) &&
            dispatch(setApplicantUser(subworkflowsObj));
          if (subworkflowsObj?.active_step) {
            if (loggedUserId) {
              dispatch(setActiveStepOrder(5));
            } else {
              dispatch(setActiveStepOrder(subworkflowsObj?.active_step));
            }
          }
        }
      }
    };
    if (decryptedId?.primaryWorkflowId) {
      fetchData();
    }
    if (decryptedId?.redirectionConfigId) {
      dispatch(getConfiguration(decryptedId?.redirectionConfigId));
    }
  }, [decryptedId]);


  useEffect(() => {
    let conditionalRedirectionSections = [];
    let formStructure = [];
    let module_access;
    let userToken = JSON.parse(localStorage.getItem("userToken"));
    conditionalRedirection?.wf_journey?.map((item, index) => {
      formStructure = { ...item?.form_structure };
      module_access = item?.module_access;
    });
    if(formStructure?.show) {
      let showFormLayout = eval(formStructure?.show);
      if(!showFormLayout) navigate("/error")
    }
    // Role based access for form innitiation starts

    if(userToken && userToken?.role && module_access) {
      let query_params = {
        role_id: userToken?.role,
        organisation_id: organisation_id
      };
      dispatch(setConfigLoading(true))
      dispatch(getRolesInfo(query_params))
      .unwrap()
      .then((result) => {
        if(result) {
          let module_info = result?.module_list.filter((item) => item.module_id == module_access);
          if(module_info.length && !(module_info[0].add && module_info[0].edit)) navigate("/error")
          else dispatch(setConfigLoading(false))
        } else dispatch(setConfigLoading(false))
      })
    }

    // Role based access for form initiation ends
    banner = formStructure?.sections?.filter((item) => item?.type === "banner");
    conditionalRedirectionSections = formStructure?.sections?.filter(
      (item) => item?.type !== "banner"
    );
    conditionalRedirectionSections?.forEach((item, index) => {
      sections[item?.order] = {
        title: item?.title,
        form_groups: item?.form_groups?.map((_item, _index) => {
          return {
            name: _item?.name,
            title: _item?.title,
            group_order: _item?.order,
            display_group: _item?.show,
            group_length: _item?.form_groups?.length,
            show: _item?.show,
            next_step : _item?.next_step,
            form_elements: _item?.form_elements,
            form_buttons: _item?.form_buttons,
            show_application_to : _item?.show_application_to
          };
        }),
        section_order: item?.order,
        element_number: index,
        display_section: item?.show,
      };
    });
    // setConditionalSection(sections);
    dispatch(setBanner(banner));
    dispatch(setSections(sections));
    dispatch(setNavOrientation(formStructure.nav_orientation))
    dispatch(setAllignmentPosition(formStructure.allignment_position))
    dispatch(setCustomStyle(formStructure.custom_style))
    dispatch(setFormOccupancy(formStructure.form_occupancy))
    if (formStructure.layout === "regular") dispatch(setStepperDisplay(false));
    else dispatch(setStepperDisplay(true));
  }, [conditionalRedirection]);

  
  
  // Mobile Responsivess - conditions - start

  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", () => checkWindowWidth());

  // Mobile Responsivess - conditions - end
  useEffect(() => {
    checkWindowWidth();
  }, []);



  const handleRedirect = async (link) => {
    const splitLink = link.split("/");
    const primaryWfId = await encryptUrl(splitLink[2]);
    const userId = await encryptUrl(splitLink[3]);
    const redirectLink = `/${splitLink[1]}/${primaryWfId}/${userId}`;
    navigate(link);
  };

  const selectWorkflow = () => {
    conditionalRedirection?.wf_decider &&
      conditionalRedirection?.wf_decider.map((item, index) => {
        const { show, value,user_initiated } = item;
        if (IndirectEval(show)) {
          dispatch(setConfigurationId(decryptedId?.redirectionConfigId));
          dispatch(setDynamicConfigId(value));
          dispatch(setUserInitiatedRequired(IndirectEval(user_initiated)))
        }
      });
    return;
  };

  // let userToken = localStorage.getItem("userToken");
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  let loggedInUserName = loggedUserId ? (`${(loggedInUserInfo?.profileInfo?.first_name || "") + " " + (loggedInUserInfo?.profileInfo?.last_name || "")}` ) : "";
  let loggedInUserEmail=loggedUserId && loggedInUserInfo?.profileInfo?.emailId  
  let loggedInUserMobileNumber = loggedUserId && loggedInUserInfo?.profileInfo?.mobileNumber
  
  const handleNext = async (params) => {
    let payload = { ...selectedData };
    // if (activeStepOrder === 2)
    if (currentStep.name === "workflows_generation" || currentStep.name === "workflows_generation_with_guardian"){
      let order = activeStepOrder;
      let applicantData;
      let uniqueName = conditionalRedirection?.application_sequence ? conditionalRedirection?.application_sequence :  conditionalRedirection?.wf_name
      let application_ref_id = uniqueWorkFlowId(uniqueName)
      let applicant_sequence = conditionalRedirection?.application_sequence
      let verification
      if(queryPath){
        //Changed Key physical_form to verification
       verification = true
      } else if (!queryPath) {
        verification = false
      }
      finalPayload = await createMasterDataPayload(
        null,
        payload,
        organisation_id,
        configurationId,
        saveData.length > 0 ? saveData : saveDataGuardian,
        isEmailVerified,
        isMobileVerified,
        params?.fieldName,
        email,
        recursiveFormData,
        order,
        dynamicConfigId,
        application_ref_id,
        loggedUserId,
        applicant_sequence,
        loggedInUserName,
        loggedInUserEmail,
        loggedInUserMobileNumber,
        null,
        params?.fieldName,
        params?.trigger,
        userInitatedRequired,
        null,
        verification
      );
      dispatch(setShowDataPreview(false));
      if(queryPath){
        //Changed Key physical_form to verification
        finalPayload.verification = true
      } else if (!queryPath) {
        finalPayload.verification = false
      }
      const sub_length= finalPayload?.source_data?.subworkflows?.length;

      if (
        currentStep?.show_application_to &&
        currentStep?.show_application_to == "user_hierarchy" &&
        loggedUserId
      ) {
        finalPayload["show_application_to"] = loggedUserId;
      }

      if (loggedUserId) {
        setIsCreateWorkFlowLoading(true);
        if(sub_length>1){
          applicantData = await createPrimaryWorkFlow(finalPayload);
        }else{
          applicantData = await createSubWorkFlow(finalPayload);
         }
        // applicantData = await createPrimaryWorkFlow(finalPayload);
        if(!queryPath){
          let stateData={
            content_trigger:params?.content_trigger,
            organisation_id:organisation_id
          }
          let encryptedData = await encrypt(stateData)
          sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
          navigate(`/dashboard/form/${redirectionConfigId}/update-successful`);
        } else if(queryPath) {
          // await createPrimaryWorkFlow(finalPayload, handleRedirect);
          handleRedirect(applicantData?.link )
          setIsCreateWorkFlowLoading(false);
        }
      } else if (!loggedUserId) {
        //* If it's a button for handling UAE Pass auth
        if(params?.isUaePassAuth) {
          setIsCreateWorkFlowLoading(true);
          const createdPrimaryWorkflow = await createPrimaryWorkFlow(finalPayload);
          /**
           ** Post this we are going to redirect the user to the auth URL returned by UAE Pass
           ** as this redirection needs some time and we want to show a loading state during that time
           ** we're NOT setting the loading state to FALSE.
           */
          return createdPrimaryWorkflow;
        }
        setIsCreateWorkFlowLoading(true);
        if(sub_length>1){
          applicantData = await createPrimaryWorkFlow(finalPayload,handleRedirect);
        }else{
          applicantData = await createSubWorkFlow(finalPayload,handleRedirect);
         }
       
      }
      dispatch(clearSaveData());
      dispatch(clearShowData());
    }

    if (currentStep.name === "applicant_consent") {
      let primarydata = JSON.parse(JSON.stringify(primaryUser));
      primarydata.userId = decryptedId?.primaryWorkflowId;
      primarydata.activeUser = decryptedId?.userId
      delete primarydata._id;
      let data = primarydata?.source_data?.subworkflows?.map((item) => {
        if (item.user_id == decryptedId?.userId) {
          return {
            ...item,
            is_consent_approved: true,
            active_step: 4,
            consents_approved: [
              {
                consent_type: consentType,
                consents_id: consentsConfig,
                consent_text: consentText,
                approved_at: moment(new Date()),
              },
            ],
          };
        } else {
          return {
            ...item,
          };
        }
      });
      primarydata.source_data.subworkflows = [...data];
      dispatch(updatePrimaryWorkflow(primarydata));
    }

    if (currentStep.name === "otp_verification") {
      let primarydata = JSON.parse(JSON.stringify(primaryUser));
      // delete primarydata._id;
      primarydata.userId = decryptedId?.primaryWorkflowId;
      let data = primarydata?.source_data?.subworkflows?.map((item) => {
        if (item.user_id == decryptedId?.userId || primarydata?.source_data?.subworkflows?.some((subworkflow) =>
          subworkflow?.email === item?.email && subworkflow?.is_verified === "false"
        )) {
          return {
            ...item,
            status : "In draft",
            is_verified: true,
            active_step: activeStepOrder,
          };
        }
        return item;
      });
      if (data.every((item) => {return item?.is_verified === true}) && primarydata.status === 'Verification Pending') {
        primarydata.status = "In draft"
      }
      primarydata.source_data.subworkflows = [...data];
      // dispatch(incrementActiveStepOrder())
      let primarydata1 = JSON.parse(JSON.stringify(primarydata));
      primarydata1.activeUser = decryptedId?.userId
      delete primarydata1._id;
      dispatch(setPrimaryUser(primarydata));
      if(applicantUser?.is_verified === false){
        dispatch(updatePrimaryWorkflow(primarydata1));
      }
      dispatch(setIsInternal(true));
      if (primarydata?.created_by !== null && applicantUser?.is_verified === false) {
        const stateData = {
          content_trigger: params?.content_trigger,
          organisation_id:organisation_id
        };
        let encryptedData = await encrypt(stateData)
        sessionStorage.setItem("stateData", JSON.stringify(encryptedData));  
        navigate("/update-successful");
      }
    }
    dispatch(clearValidateTriggered());
    dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
  };
  const handleSkip = () => {
    dispatch(clearValidateTriggered());
    dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
  };

  const handleAdd = (type) => {
    //arrayName -> The name with which the recursive data gets saved in the DB
    let arrayName = fields[0].input_fields.filter(
      (item) => item.type == "toggle"
    );
    dispatch(setArrayName(arrayName[0]?.name));

    let formattedFormFields = fields[0].input_fields.filter(
      (item) => item.type != "toggle"
    );


    let setShowRecursiveData = {},
      saveRecursiveData = {},
      countryCode,
      mobile,
      completeMobileNumber,
      major,
      age;
    if (type === "guardian") {
    dispatch(setFormFieldsGuardian(formattedFormFields));
    dispatch(setRecursiveActionsGuardian(fields[0]?.recursive_actions));
      let recursiveFormData = structuredClone(recursiveFormDataGuardian)
      countryCode = recursiveFormData?.country_code;
      major = recursiveFormData?.majority;
      age = recursiveFormData?.age;

      formattedFormFields.map((item, index) => {
        //* If condition because the recursiveNameFields might have undefined values
        if (recursiveFormData[item.name]&& IndirectEval(item.show)) {
          saveRecursiveData[item.name] = recursiveFormData[item.name];
          setShowRecursiveData[item.name] = recursiveFormData[item.name];
        }
      });


      Object.keys(recursiveFormData).map((key) => {
        if (key.includes("country_code")) {
          saveRecursiveData[key] = countryCode;
        }
      });
      Object.keys(recursiveFormData).map((key) => {
        if (key.includes("majority")) {
          saveRecursiveData[key] = major;
        }
      });
      Object.keys(recursiveFormData).map((key) => {
        if (key.includes("age")) {
          saveRecursiveData[key] = age;
        }
      });
      let recursiveNameFields = [];
      fields[0].input_fields.map((item) => {
        if (item.type == "toggle") return;
        return recursiveNameFields.push({ name: item.name, label: item.label });
      });

      recursiveNameFields.map((item) => {
        dispatch(clearRecursiveFormDataKey({ key: item.name }));
      });
    }
    else {
    dispatch(setFormFields(formattedFormFields));
    dispatch(setRecursiveActions(fields[0]?.recursive_actions));
    countryCode = recursiveFormData?.country_code;
    major = recursiveFormData?.majority;
    age = recursiveFormData?.age;

    formattedFormFields.map((item, index) => {
      //* If condition because the recursiveNameFields might have undefined values
      if (recursiveFormData[item.name]&& IndirectEval(item.show)) {
        saveRecursiveData[item.name] = recursiveFormData[item.name];
        setShowRecursiveData[item.name] = recursiveFormData[item.name];
      }
    });
    

    Object.keys(recursiveFormData).map((key) => {
      if (key.includes("country_code")) {
        saveRecursiveData[key] = countryCode;
      }
    });
    Object.keys(recursiveFormData).map((key) => {
      if (key.includes("majority")) {
        saveRecursiveData[key] = major;
      }
    });
    Object.keys(recursiveFormData).map((key) => {
      if (key.includes("age")) {
        saveRecursiveData[key] = age;
      }
    });
    let recursiveNameFields = [];
    fields[0].input_fields.map((item) => {
      if (item.type == "toggle") return;
      return recursiveNameFields.push({ name: item.name, label: item.label });
    });

    recursiveNameFields.map((item) => {
      dispatch(clearRecursiveFormDataKey({ key: item.name }));
    });
    }
    if (type === "guardian") {
      saveRecursiveData.uid = uuidv4().replace(/-/g, "")
      dispatch(setShowDataGuardian(setShowRecursiveData))
      dispatch(setAddSaveDataGuardian(saveRecursiveData))
      dispatch(setShowRecursiveFormGuardian(false));
      dispatch(setShowAddMoreGuardian(true));
      dispatch(setShowDataPreviewGuardian(true));
      dispatch(clearRecursiveFormDataGuardian());
    } else {
      dispatch(setShowData(setShowRecursiveData));
      dispatch(setAddSaveData(saveRecursiveData));
      dispatch(setShowRecursiveForm(false));
      dispatch(setShowAddMore(true));
      dispatch(setShowDataPreview(true));
    }
  };

  const handleCancel = () => {
    dispatch(setShowAddMore(true));
    showRecursiveForm && dispatch(setShowRecursiveForm(false));
    !showRecursiveForm && dispatch(clearRecursiveFormData());
    dispatch(setIsEditRecursiveForm(false));
    dispatch(setEditIndex(-1));
    isMinor && dispatch(setIsMinor(false));
  };
  const handleCancelGuardian = () => {
    dispatch(setShowAddMoreGuardian(true));
    dispatch(setShowRecursiveFormGuardian(false));
    !showRecursiveForm && dispatch(clearRecursiveFormDataGuardian());
    dispatch(setIsEditRecursiveFormGuardian(false));
    dispatch(setEditIndexGuardian(-1));
  };


  const handleBack = () => {
    setFormErr({});
    dispatch(clearValidateTriggered());
    dispatch(clearSaveData());
    dispatch(clearShowData());
    dispatch(setActiveStepOrder(activeStepOrder - 1));
    dynamicFormScroll();
  };

  /**
   ** This function initiates the Authentication process with UAE Pass
   ** To use this function use the button action as {uae_pass_auth} in the config
   */
  const handleUaePassAuth = async (fieldName, trigger) => {
    try {
      /**
       ** We need to redirect the user to the current link in case of UAE Pass Auth fails 
       */
      const currentUrl = window.location.href;

      /**
       ** Finding the Dynamic Config ID based on the show condition of the
       ** workflow decider
       */
      const dynamic_configuration_id = conditionalRedirection?.wf_decider?.reduce((id, currItem) => {
        if(IndirectEval(currItem?.show))
          id = currItem.value;
        return id;
      }, -1);

      let uniqueName = conditionalRedirection?.application_sequence ? conditionalRedirection?.application_sequence :  conditionalRedirection?.wf_name
      let application_ref_id = uniqueWorkFlowId(uniqueName)
      /**
       ** 3 params i.e. organisation_id and configuration_id and uae_pass_initiation_link
       **  are mandatory and others are not.
       */
      const payload = {
        ...selectedData,
        organisation_id,
        configuration_id: dynamic_configuration_id,
        application_ref_id,
        uae_pass_initiation_link: currentUrl
      };

      const response = await initiateUaePassAuth({...payload});

      // * If we the UAE pass auth is successfully initiated
      if(response?.status.toLowerCase() === "success") {
        const authenticationUrl = response.data?.authentication_url;
        if(!authenticationUrl) throw new Error("Authentication URL is not found!");

        // * Navigating the user to the UAE Pass authentication URL
        window.location.replace(authenticationUrl);
      }

    } catch (err) {
      console.log(err);
    }
  }

  const validateAndSubmit = async ( 
    action,
   params) => {
   
    let validateFields = [];

    fields.map((item) => {
      if (
        item.type == "group" ||
        item.type == "recursive" ||
        item.type == "questionnaire" ||
        item.type === "guardian_recursive"
      ) {
        let selectToggleFields = false;
        item.input_fields?.map((_item) => {
          if (_item.type == "toggle") {
            selectToggleFields = true;
          }
          if (
            selectToggleFields &&
            _item.hasOwnProperty("show") &&
            IndirectEval(item.show)
          ) {
            validateFields = [...validateFields, _item];
          }
          if (!selectToggleFields) {
            let selectDependentFields = true;
            if (_item.hasOwnProperty("show")) {
              selectDependentFields = IndirectEval(_item.show);
            }
            if (selectDependentFields)
              validateFields = [...validateFields, _item];
          }
        });
      } else {
        let fieldVisiblity = false;
        if (item.hasOwnProperty("show"))
          fieldVisiblity = IndirectEval(item?.show);
        else fieldVisiblity = true;
        if (fieldVisiblity) {
          validateFields = [...validateFields, item];
        } else {
          dispatch(clearSelectedDataKey({key : item.name}))
        }
      }
    });

    let errors;
    if (params?.isRecursive) {
      if(action === "addGuardian")
        errors = await validate(validateFields, recursiveFormDataGuardian, dispatch, staticData);
      else
      errors = await validate(validateFields, recursiveFormData, dispatch, staticData);     
    } else {
      if ((dataPreview || dataPreviewGuardian) && (!showRecursiveForm || !showRecursiveFormGuardian)) {
        errors = {};
      } else {
        errors = await validate(validateFields, selectedData, dispatch,staticData);
      }
    }

    let errKeys = Object.keys(errors);
    // console.log("errror", errKeys, isRecursive);
    if (errKeys?.length === 0) {
      switch (action) {
        case "add":
          selectWorkflow && selectWorkflow();
          handleAdd();
          break;
        case "addGuardian":
          handleAdd("guardian")
          break;
        case "next":
          handleNext(params);
          break;
        case "uae_pass_auth":
          handleUaePassAuth(params?.id, params?.trigger);
          break;
        //* MOVE handleEdit also here to avoid having same validation code inside recursion
        default:
          break;
      }
      return;
    } else {
      setFormErr(errors);
      dynamicFormScroll();
    }
  };

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...stateErrRef?.current };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }

    setFormErr(err);
  };
  const switchingProfile = async (
    primaryWorkflowId,
    userId,
    subWfId,
    is_verified
  ) => {
    dispatch(setConfigLoading(true))
    const sourceData = primaryUser?.source_data;
    const primary_workflow_id = await encryptUrl(primaryWorkflowId);
    const user_id = await encryptUrl(loggedUserId ? loggedUserId : userId);
    const sub_workflow_id = await encryptUrl(subWfId);
    const subId = await encryptUrl(loggedUserId ? loggedUserId : decryptedId?.userId);
    if (is_verified) {
      if (userId == sub_id) {
        sourceData.subworkflows.forEach((element) => {
          if (subWfId == element._id) {
            dispatch(setworkflowUser({ ...sourceData, subworkflows: element }));
          }
        });
        navigate(
          `/formSubmission/${primary_workflow_id}/${user_id}/${sub_workflow_id}${(loggedUserId && "?userInitiated=true") || ""}`
        );
        dispatch(clearSelectedData());
      } else {
        primaryUser?.source_data?.subworkflows?.map(async (item) => {
          if (userId == item?.user_id) {
            dispatch(setworkflowUser({ ...sourceData, subworkflows: item }));
            const _id = await encryptUrl(item?._id);
            navigate(`/formSubmission/${primary_workflow_id}/${subId}/${_id}${(loggedUserId && "?userInitiated=true") || ""}`);
            dispatch(clearSelectedData());
          }
        });
      }
    }
  };

  const populateStepper = (_item) => {
    let updatedSections = {
      1: {
        title: stepperSections[1]?.title,
        section_order: 1,
        element_number: 0,
        display_section: true,
        form_groups: stepperSections[1]?.form_groups?.map((item, index) => {
          return {
            ...item,
            form_elements: item?.form_elements?.map((_item, index) => {
              if (_item.type === "consent") {
                return {
                  ..._item,
                  title: _item.title,
                  type: "singleConsent",
                };
              }
              return {
                ..._item,
              };
            }),
          };
        }),
      },
    };
    dispatch(setSections(updatedSections));
  };

  //spinnner to load ddf
  if ( loading || userInfoLoading || isCreateWorkFlowLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Layout landing={true} nav_orientation={navOrientation} allignment_position={allignmentPosition} formErr={validateAndSubmit} custom_style={cutstomStyle}>
      {Object.entries(stepperSections)?.map((section, index) => {
        index = parseInt(section[0]);
        section = section[1];
        const { section_order, is_last_section, redirect_url } = section;
        if (section_order === activeSection) {
          return section?.form_groups?.map((item, index) => {
            if (Number(item.group_order) === activeStepOrder) {
              if (eval(item.show)) {
                fields = item?.form_elements;
                return (
                  <Fragment key={index}>
                    {fields?.map((_item, _index) => {
                      if (_item.type === "recursive") {
                        return (
                          <Fragment key={_index}>
                            <Recursive
                              recursiveTrigger={_item.recursive_trigger}
                              customStyle={_item.custom_style}
                              inputFields={_item.input_fields}
                              handleNext={validateAndSubmit}
                              handleAdd={handleAdd}
                              handleCancel={handleCancel}
                              selectedData={recursiveFormData}
                              setSelectedData={setRecursiveFormData}
                              recursiveActions={_item.recursive_actions}
                              dataPreview={dataPreview}
                              clearFieldError={clearFieldError}
                              formErr={formErr}
                              setFormErr={setFormErr}
                              recursiveTitle={_item.recursive_title}
                              minLength={_item.min_length}
                              maxLength={_item.max_length}
                            />
                          </Fragment>
                        );
                      }
                      if (_item.type === "guardian_recursive") {
                        return (
                          <Fragment key={_index}>
                            <GuardianRecursive
                              recursiveTrigger={_item.recursive_trigger}
                              inputFields={_item.input_fields}
                              handleNext={validateAndSubmit}
                              handleAdd={handleAdd}
                              handleCancel={handleCancelGuardian}
                              selectedData={recursiveFormDataGuardian}
                              setSelectedData={setRecursiveFormDataGuardian}
                              recursiveActions={_item.recursive_actions}
                              dataPreview={dataPreviewGuardian}
                              clearFieldError={clearFieldError}
                              formErr={formErr}
                              setFormErr={setFormErr}
                              recursiveTitle={_item.recursive_title}
                              guardianKey={_item.guardian_key}
                              guardianLabel={_item.guardian_label}
                              maxGuardianLimit={_item.max_guardian_limit}
                              minLength={_item.min_length}
                              maxLength={_item.max_length}
                            />
                          </Fragment>
                        );
                      }
                      if (_item.type === "consent") {
                        populateStepper(_item);
                        return;
                      }
                      if (_item.type === "singleConsent") {
                        return (
                          <Fragment key={index}>
                            <Consent
                              consentName={_item.name}
                              layout={_item.layout}
                              consent={_item.consents[0]}
                              setSelectedData={setSelectedData}
                            />
                          </Fragment>
                        );
                      }
                      if (_item.type === "group") {
                        return (
                          <Fragment key={_index}>
                            <Group
                              formErr={formErr}
                              clearFieldError={clearFieldError}
                              formFields={_item?.input_fields}
                              handleNext={handleNext}
                              handleCancel={handleCancel}
                              handleAdd={handleAdd}
                              selectedData={selectedData}
                              setSelectedData={setSelectedData}
                              custom_styles={_item.custom_styles}
                            />
                          </Fragment>
                        );
                      } else {
                        return (
                      <Row>
                            <Fragment key={_index}>
                            <DynamicForm
                              formFields={_item}
                              setSelectedData={setSelectedData}
                              selectedData={selectedData}
                              formErr={formErr}
                              clearFieldError={clearFieldError}
                              switchingProfile={switchingProfile}
                              primaryUser={primaryUser}
                            />
                          </Fragment>
                       </Row>
                        );
                      }
                    })}
                    <FormButton
                      formButtons={item?.form_buttons}
                      handleNext={validateAndSubmit}
                      handleCancel={handleCancel}
                      selectedData={selectedData}
                      selectWorkflow={selectWorkflow}
                      handleBack={handleBack}
                      handleUaePassAuth={handleUaePassAuth}
                    />
                  </Fragment>
                );
              } else handleSkip();
            }
          });
        }
      })}
    </Layout>
  );
};

export default ConditionalRendering;
